import React from 'react';
import { useHistory } from 'hooks/router';
import Inputs from 'components/inputs/inputs';

import image_error from 'assets/images/error-page-missing.png';

export default function ErrorPageNotFound(props) {
  const history = useHistory();

  return (
    <div className='d-flex justify-content-center align-items-center vw-100 vh-100'>
      <div className='col-xs-10 col-sm-10 col-lg-8'>
        <div>
          <div className='text-center'>
            <img src={image_error} alt='Error' />
          </div>
          <div className='text-center'>
            <h1 className='text-danger font-weight-lighter mt-2'>Page could not be found</h1>
          </div>
          <div className='d-flex flex-column justify-content-between align-items-center'>
            <Inputs.Button variant='default' className='my-2' onClick={() => history.goBack()}>Back To Previous Page</Inputs.Button>
            <Inputs.Button variant='default' className='my-2' onClick={() => history.push('/')}>Go Home</Inputs.Button>
          </div>
          <div className='text-center'>
            <h5 className='text-normal mt-3'>We're sorry we could not locate the page you requested.</h5>
          </div>
        </div>
      </div>
    </div>
  );
}